import { LegalLayout, LegalSection } from "../components/LegalLayout";

export default function AGB() {
  return (
    <LegalLayout
      title="AGB"
      subtitle="Allgemeine Geschäftsbedingungen von Urban Beauty Klosters."
    >
      <LegalSection heading="1. Geltungsbereich">
        <p>
          Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle
          Dienstleistungen und Behandlungen, die von Urban Beauty Klosters
          angeboten und erbracht werden. Mit der Buchung eines Termins
          akzeptieren Sie diese AGB.
        </p>
      </LegalSection>

      <LegalSection heading="2. Terminvereinbarung">
        <p>
          Termine können online, telefonisch oder persönlich vereinbart werden.
          Eine Buchung gilt erst nach unserer Bestätigung als verbindlich. Wir
          bitten Sie, pünktlich zu erscheinen, damit die geplante Behandlung in
          vollem Umfang durchgeführt werden kann.
        </p>
      </LegalSection>

      <LegalSection heading="3. Preise und Zahlung">
        <p>
          Es gelten die zum Zeitpunkt der Buchung kommunizierten Preise in
          Schweizer Franken (CHF), inklusive der gesetzlichen Mehrwertsteuer,
          sofern anwendbar. Die Zahlung erfolgt nach der Behandlung vor Ort,
          sofern nichts anderes vereinbart wurde.
        </p>
      </LegalSection>

      <LegalSection heading="4. Absage und Stornierung">
        <p>
          Sollten Sie einen Termin nicht wahrnehmen können, bitten wir um eine
          Absage mindestens 24 Stunden im Voraus. Bei nicht rechtzeitiger Absage
          oder Nichterscheinen behalten wir uns vor, einen Teil oder den
          gesamten Behandlungspreis in Rechnung zu stellen.
        </p>
      </LegalSection>

      <LegalSection heading="5. Gutscheine">
        <p>
          Gutscheine sind ab Ausstellungsdatum 2 Jahre gültig und können für
          alle Dienstleistungen eingelöst werden. Eine Barauszahlung ist nicht
          möglich.
        </p>
      </LegalSection>

      <LegalSection heading="6. Haftung">
        <p>
          Unsere Behandlungen werden mit grösster Sorgfalt durchgeführt. Bitte
          informieren Sie uns vor der Behandlung über gesundheitliche
          Beschwerden, Allergien oder Unverträglichkeiten. Für Schäden, die auf
          nicht mitgeteilte gesundheitliche Umstände zurückzuführen sind, wird
          keine Haftung übernommen.
        </p>
      </LegalSection>

      <LegalSection heading="7. Anwendbares Recht und Gerichtsstand">
        <p>
          Es gilt ausschliesslich Schweizer Recht. Gerichtsstand ist Klosters,
          Schweiz.
        </p>
      </LegalSection>

      <LegalSection>
        <p className="text-sm italic">
          Stand: Juni 2026.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
